module.exports = __webpack_public_path__ + "img/BespokeJet.f2fd3979.png";